import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '@/assets/img/meeting/pc-logo.png'
import _imports_1 from '@/assets/img/meeting/envo-logo-text.png'
import _imports_2 from '@/assets/img/meeting/no_meeting.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "pc_header" }
const _hoisted_3 = {
  key: 0,
  class: "meeting"
}
const _hoisted_4 = { class: "meeting_name" }
const _hoisted_5 = { class: "meeting_number" }
const _hoisted_6 = { class: "meeting_creator" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "meeting_creator-name" }
const _hoisted_9 = { class: "meeting_creator-role" }
const _hoisted_10 = { class: "meeting_info" }
const _hoisted_11 = { class: "meeting_info-time" }
const _hoisted_12 = { class: "time" }
const _hoisted_13 = { class: "meeting_info-time_main" }
const _hoisted_14 = { class: "time_main-block" }
const _hoisted_15 = { class: "time" }
const _hoisted_16 = { class: "meeting_info-date" }
const _hoisted_17 = { class: "date" }
const _hoisted_18 = { class: "date" }
const _hoisted_19 = {
  key: 0,
  class: "meeting_qrcode"
}
const _hoisted_20 = {
  key: 1,
  class: "meeting_status_view"
}
const _hoisted_21 = ["src"]
const _hoisted_22 = {
  key: 2,
  class: "meeting_status_view"
}
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "meeting_action" }
const _hoisted_25 = {
  key: 1,
  class: "no_meeting"
}
const _hoisted_26 = {
  key: 1,
  class: "loading"
}
const _hoisted_27 = {
  key: 2,
  class: "meeting_join_overlay"
}
const _hoisted_28 = { class: "join_overlay_nav" }
const _hoisted_29 = { class: "join_overlay_content" }
const _hoisted_30 = ["src"]

import {
  getConferenceShareInfoApi,
  touristsJoinConferenceApi,
} from '@/api/meeting';
import useDownloadApp from '@/hooks/useDownloadApp';
import useOpenApp from '@/hooks/useOpenApp';
import dayjs from 'dayjs';
import { QrcodeSvg } from 'qrcode.vue';
import { computed, h, onMounted, onUnmounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { LoadingOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import ErrorUser from '@/assets/img/meeting/error_user.png';
import Header from '@/components/header.vue';
import i18n from '@/language';
import TimeLimitImage from '@/assets/img/meeting/time.png';
import FinishedImage from '@/assets/img/meeting/finished.png';
import EnvoJoinLogo from '@/assets/img/meeting/envo-join-logo.png';
import {
  getGuestRtcPayload,
  joinGuestRtcSession,
  saveGuestRtcPayload,
} from '@/utils/meetingGuestRtc';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { openApp } = useOpenApp();

const { downloadApp } = useDownloadApp();
const conferenceTypeMap: any = {
  1: '语音',
  2: '轻演',
  3: '高级',
};
const roomStatusMap = {
  waitOpen: ['1', 'wait_open'],
  running: ['2', 'running'],
  over: ['3', 'over'],
};
const route = useRoute();
const router = useRouter();
const t = i18n.global.t;

const loading = ref(false);
const joiningMeeting = ref(false);
const originalTheme = ref<string | null>(null);
const originalColorScheme = ref('');

const qrcodeValue = ref('');

const detail = ref<any>();
const touristLimitReached = ref(false);
const isMeetingOver = computed(() => {
  return roomStatusMap.over.includes(String(detail.value?.roomStatus));
});
const isGuestJoinAllowed = computed(() => {
  return (
    roomStatusMap.running.includes(String(detail.value?.roomStatus)) &&
    !detail.value?.joinNeedPay
  );
});
const isShareViewLimitReached = computed(() => {
  return (
    isGuestJoinAllowed.value &&
    typeof detail.value?.viewDuration === 'number' &&
    detail.value.viewDuration === 0
  );
});
const isTouristLimitReached = computed(() => {
  return touristLimitReached.value || isShareViewLimitReached.value;
});
const isChineseLocale = computed(() => {
  const locale = String(i18n.global.locale || '');
  return locale === 'zh' || locale === 'zhTw';
});

const getConferenceShareInfo = async (options: { silent?: boolean } = {}) => {
  try {
    if (!options.silent) {
      loading.value = true;
    }

    const id = route.query.id as string | undefined;

    if (id) {
      const res = await getConferenceShareInfoApi(id);

      if (res.value.code === 0) {
        const result = res.value.result;
        detail.value = result;
      }
    }
  } catch (error) {
  } finally {
    if (!options.silent) {
      loading.value = false;
    }
  }
};

const indicator = h(LoadingOutlined, {
  style: {
    fontSize: '48px',
  },
  spin: true,
});

function useDefaultImage(event: any) {
  event.target.src = ErrorUser;
}

function showMeetingToast(content: string) {
  message.open({
    content,
    duration: 2,
    class: 'meeting_status_message',
  });
}

function getTouristsDuration(res: any) {
  return Number(
    res?.value?.result?.touristsDuration ??
      res?.value?.data?.touristsDuration ??
      res?.value?.touristsDuration,
  );
}

function normalizeTouristJoinResult(res: any) {
  return res?.value?.result ?? res?.value?.data ?? res?.value ?? {};
}

function openOfficialWebsite() {
  window.open('https://www.envo.world/', '_blank', 'noopener,noreferrer');
}

function forceLightTheme() {
  const root = document.documentElement;
  originalTheme.value = root.getAttribute('data-theme');
  originalColorScheme.value = root.style.colorScheme;
  root.setAttribute('data-theme', 'light');
  root.style.colorScheme = 'light';
}

function restoreTheme() {
  const root = document.documentElement;

  if (originalTheme.value === null) {
    root.removeAttribute('data-theme');
  } else {
    root.setAttribute('data-theme', originalTheme.value);
  }

  root.style.colorScheme = originalColorScheme.value;
}

async function handleWebGuestJoin() {
  if (joiningMeeting.value) return;

  await getConferenceShareInfo({ silent: true });

  const roomStatus = String(detail.value?.roomStatus);

  if (roomStatusMap.waitOpen.includes(roomStatus)) {
    showMeetingToast(t('会议未开始，可前往客户端APP预定会议'));
    return;
  }

  if (roomStatusMap.over.includes(roomStatus)) {
    showMeetingToast(t('当前会议已结束'));
    return;
  }

  if (roomStatusMap.running.includes(roomStatus)) {
    if (detail.value?.joinNeedPay) {
      showMeetingToast(t('当前会议需付费加入，请在客户端APP中打开'));
      return;
    }

    if (isShareViewLimitReached.value) {
      touristLimitReached.value = true;
      return;
    }

    const id = String(detail.value?.id ?? route.query.id ?? '');

    if (!id) return;

    try {
      joiningMeeting.value = true;
      const res = await touristsJoinConferenceApi(id);
      const code = Number(res?.value?.code);
      const result = normalizeTouristJoinResult(res);

      if (code === 250050) {
        joiningMeeting.value = false;
        showMeetingToast(t('会议太火爆，暂无位置，请稍后再试'));
        return;
      }

      const touristsDuration = getTouristsDuration(res);

      if (code === 250052) {
        joiningMeeting.value = false;
        touristLimitReached.value = true;
        return;
      }

      if (Number.isFinite(touristsDuration) && touristsDuration <= 0) {
        joiningMeeting.value = false;
        touristLimitReached.value = true;
        return;
      }

      if (code === 0) {
        if (!saveGuestRtcPayload(id, result)) {
          joiningMeeting.value = false;
          showMeetingToast(t('游客入会失败，请稍后再试'));
          return;
        }

        const rtcPayload = getGuestRtcPayload(id);

        if (!rtcPayload) {
          joiningMeeting.value = false;
          showMeetingToast(t('游客入会失败，请稍后再试'));
          return;
        }

        await joinGuestRtcSession(rtcPayload);

        await router.push({
          name: 'MeetingRoom',
          query: {
            ...route.query,
            id,
          },
        });
      }

      if (code !== 0) {
        joiningMeeting.value = false;
        showMeetingToast(t('连接失败'));
      }
    } catch (error) {
      console.error('[meeting] web guest join failed', error);
      joiningMeeting.value = false;
      showMeetingToast(t('连接失败'));
    }

    return;
  }
}

onMounted(() => {
  forceLightTheme();
  qrcodeValue.value = window.location.href;

  getConferenceShareInfo();
});

onUnmounted(() => {
  restoreTheme();
});

return (_ctx: any,_cache: any) => {
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header, {
      "button-text": "XZ",
      "button-click": _unref(downloadApp),
      size: "large",
      "force-light": ""
    }, null, 8, ["button-click"]),
    _createElementVNode("header", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("img", {
        src: _imports_0,
        alt: "Envo"
      }, null, -1)),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(downloadApp) && _unref(downloadApp)(...args)))
      }, _toDisplayString(_ctx.$t('下载')), 1)
    ]),
    (!loading.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (detail.value?.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("h1", _hoisted_4, [
                  _createElementVNode("span", {
                    class: _normalizeClass([{
              conferenceType1: detail.value?.conferenceType === 1,
              conferenceType2: detail.value?.conferenceType === 2,
              conferenceType3: detail.value?.conferenceType === 3,
            }, "meeting_name_light"])
                  }, _toDisplayString(_ctx.$t(conferenceTypeMap[detail.value?.conferenceType])), 3),
                  _createTextVNode(" " + _toDisplayString(detail.value?.roomName), 1)
                ]),
                _createElementVNode("p", _hoisted_5, _toDisplayString(detail.value?.id), 1),
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "dividing_line line_1" }, null, -1)),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("img", {
                    src: detail.value?.avatar,
                    onErrorOnce: useDefaultImage,
                    alt: ""
                  }, null, 40, _hoisted_7),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(detail.value?.displayName), 1),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('主持人')), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(dayjs)(detail.value?.startTime).format('HH:mm')), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('{number}分钟', { number: detail.value?.duration })), 1)
                        ]),
                        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "dividing_line" }, null, -1))
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(dayjs)(detail.value?.endTime).format('HH:mm')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(dayjs)(detail.value?.startTime).format(_ctx.$t('dateFormat'))), 1)
                    ]),
                    _cache[6] || (_cache[6] = _createElementVNode("div", null, [
                      _createElementVNode("span", { class: "date" }, "GMT+08:00")
                    ], -1)),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(dayjs)(detail.value?.endTime).format(_ctx.$t('dateFormat'))), 1)
                    ])
                  ])
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "dividing_line line_2" }, null, -1)),
                (!isTouristLimitReached.value && !isMeetingOver.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createVNode(_unref(QrcodeSvg), {
                        class: "qrcode",
                        value: qrcodeValue.value,
                        background: 'transparent'
                      }, null, 8, ["value"]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('请使用手机端「Envo App」扫码加入')), 1),
                      _cache[7] || (_cache[7] = _createElementVNode("img", {
                        src: _imports_1,
                        alt: ""
                      }, null, -1))
                    ]))
                  : (isMeetingOver.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createElementVNode("img", {
                          src: _unref(FinishedImage),
                          alt: ""
                        }, null, 8, _hoisted_21),
                        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('会议已结束')), 1),
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t('更多精彩内容请前往 Envo APP')), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createElementVNode("img", {
                          src: _unref(TimeLimitImage),
                          alt: ""
                        }, null, 8, _hoisted_23),
                        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('观看时长已达上限')), 1),
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t('登录账号可继续观看完整会议')), 1)
                      ])),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("button", {
                    class: "btn btn_primary",
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(openApp) && _unref(openApp)(...args)))
                  }, _toDisplayString(isTouristLimitReached.value || isMeetingOver.value
                ? _ctx.$t('前往Envo观看')
                : _ctx.$t('从Envo应用加入')), 1),
                  (!isTouristLimitReached.value && !isMeetingOver.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn_secondary",
                        type: "button",
                        onClick: handleWebGuestJoin
                      }, _toDisplayString(_ctx.$t('网页版游客入会')), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(["actions_text", { actions_text_multiline: !isChineseLocale.value }])
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('尚未安装Envo应用？')), 1),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(downloadApp)()))
                    }, _toDisplayString(_ctx.$t('立即下载')), 1),
                    _cache[8] || (_cache[8] = _createElementVNode("i", null, null, -1)),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: openOfficialWebsite
                    }, _toDisplayString(_ctx.$t('Envo官网')), 1)
                  ], 2)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _cache[11] || (_cache[11] = _createElementVNode("img", {
                  src: _imports_2,
                  alt: ""
                }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('会议不存在')), 1)
              ]))
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createVNode(_component_a_spin, { indicator: _unref(indicator) }, null, 8, ["indicator"]),
          _cache[12] || (_cache[12] = _createElementVNode("span", null, "loading...", -1))
        ])),
    (joiningMeeting.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _cache[13] || (_cache[13] = _createElementVNode("button", {
              class: "join_overlay_back",
              type: "button",
              "aria-label": "back"
            }, [
              _createElementVNode("span")
            ], -1)),
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('Envo会议')), 1),
            _createElementVNode("button", {
              class: "join_overlay_download",
              type: "button",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(downloadApp) && _unref(downloadApp)(...args)))
            }, _toDisplayString(_ctx.$t('下载')), 1)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("img", {
              src: _unref(EnvoJoinLogo),
              alt: "Envo"
            }, null, 8, _hoisted_30),
            _createElementVNode("h2", null, _toDisplayString(_ctx.$t('正在加入Envo会议...')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('请稍后')), 1),
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "join_progress" }, [
              _createElementVNode("i")
            ], -1))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})